export function loadNewPaymentsOptions({data = null, appName = ''} = {}) {
  let count = 5;
  const success = () => {
    if (data) {
      window.initPayment(data);
    }
  };
  const error = (err, scriptTag, callback) => {
    count--;
    console.trace(err);
    scriptTag.parentNode.removeChild(scriptTag);
    if (count) {
      callback();
    }
  };
  function loadJS() {
    const jsElm = document.createElement('script');
    jsElm.type = 'application/javascript';
    jsElm.src = `${__ENV_CONFIG__['__GOIBIBO__']}/mudra/dist/loadPayments.js?cb=${Math.random()}`;
    jsElm.onload = success;
    jsElm.onerror = () => {
      error('payments failed', jsElm, loadJS);
    };
    document.body.appendChild(jsElm);
  }
  loadJS();
}
